import { render } from "./SideMenuAdmin.vue?vue&type=template&id=40ec2f2f&scoped=true"
import script from "./SideMenuAdmin.vue?vue&type=script&lang=js"
export * from "./SideMenuAdmin.vue?vue&type=script&lang=js"

import "./SideMenuAdmin.vue?vue&type=style&index=0&id=40ec2f2f&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/nodebee_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ec2f2f"]])

export default __exports__